import { TCurrentUser } from "models/users.models";
import { TPossibleAsset } from "utils/types";

const getIsAssetCreatedByUser = (
  asset: TPossibleAsset,
  user: TCurrentUser | undefined,
) => !!(asset?.createdBy && user?.email) && asset?.createdBy === user?.email;

export default getIsAssetCreatedByUser;
